
import { QuestionCircleOutlined, CopyOutlined, LineOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, Input, InputNumber, Row, Select, theme } from 'antd';
import React from 'react';

interface IEAttributeForm {
    title?: string,
    viewMode: number,
    form?: any,
    isOrg?: true | false
    data: any[]
    type?: number
    isView?: true | false
    isPart?: true | false
    isInbound?: true | false
}

const EAttributeForm = (props: IEAttributeForm) => {
    const createControl = (item: any) => {
        var options: any = [];
        var control = <></>
        switch (item.fillFormatEnum) {
            case 0:
                control = <Input onFocus={() => {
                    props.form?.current?.scrollToField(('org' + item.customName));
                    props.form?.current?.scrollToField(item.customName.toLowerCase());
                }} disabled={props.viewMode == 2 || item.fillControlEnum == 0 || item.fillControlEnum == 3} style={{ width: '100%' }} />
                break;
            case 1:
                control = <InputNumber onFocus={() => {
                    props.form?.current?.scrollToField(('org' + item.customName));
                }} min={item.isCanZero ? 0 : 1}
                    disabled={props.viewMode == 2 || item.fillControlEnum == 0 || item.fillControlEnum == 3} style={{ width: '100%' }
                    } />
                break;
            case 2:
                control = <DatePicker onFocus={() => {
                    props.form?.current?.scrollToField(('org' + item.customName));
                    props.form?.current?.scrollToField(item.customName.toLowerCase());
                }} format={'YYYY-MM-DD'} disabled={props.viewMode == 2 || item.fillControlEnum == 0 || item.fillControlEnum == 3} style={{ width: '100%' }} />
                break;
            case 3:
                control = <DatePicker onFocus={() => {
                    props.form?.current?.scrollToField(('org' + item.customName));
                    props.form?.current?.scrollToField(item.customName.toLowerCase());
                }} format={'YYYY-MM-DD HH:mm:ss'} showTime disabled={props.viewMode == 2 || item.fillControlEnum == 0 || item.fillControlEnum == 3} style={{ width: '100%' }} />
                break;
            case 4:
                if (item.defaultValue && item.defaultValue != '') {
                    var dataArray = (item.defaultValue ?? '').split('\n');
                    dataArray.map((item: any) => {
                        options.push({ value: item, label: item });
                    })
                }
                control = <Select onFocus={() => {
                    props.form?.current?.scrollToField(('org' + item.customName));
                    props.form?.current?.scrollToField(item.customName.toLowerCase());
                }} disabled={props.viewMode == 2 || item.fillControlEnum == 0 || item.fillControlEnum == 3}
                    style={{ width: '100%' }}
                    options={options}
                    showSearch
                    optionFilterProp="children"
                    filterOption={filterOption} />
                break;
            case 5:
                control = <Select onFocus={() => {
                    props.form?.current?.scrollToField(('org' + item.customName));
                    props.form?.current?.scrollToField(item.customName.toLowerCase());
                }} disabled={props.viewMode == 2 || item.fillControlEnum == 0 || item.fillControlEnum == 3}
                    style={{ width: '100%' }}
                    options={options}
                    showSearch
                    optionFilterProp="children"
                    filterOption={filterOption} />
                break;
            default:
                control = <Input onFocus={() => {
                    var name = (!props.isOrg ? ('org' + item.customName) : item.customName.toLowerCase());
                    props.form?.current?.scrollToField(name);
                }} disabled={props.viewMode == 2} style={{ width: '100%' }} />
                break;
        }
        return control;
    }

    const filterOption = (input: any, option?: { label: any; value: any }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const createContent = () => {
        var content: any[] = [];
        var rowItems: any[] = [];
        var data = props.data ?? [];
        (data).map((item: any, index: number) => {
            var name = (props.isOrg ? ('org' + item.customName) : item.customName.toLowerCase());
            var required = (!props.isView && item.isActive && item.fillControlEnum == 1);
            if (props.isPart) {
                if (props.isInbound) {
                    required = (!props.isView && item.isActive && item.inPlanFillControlEnum == 1);
                } else {
                    required = (!props.isView && item.isActive && item.partFillControlEnum == 1);
                }
            }
            rowItems.push(
                <Col span={12}><Form.Item id={name} hidden={!item.isActive} style={{ marginBottom: '5px' }}
                    name={name}
                    label={item.showLabel}
                    initialValue={item.showValues ?? ''}
                    rules={[{
                        required: required, message: '请输入' + item.showLabel
                    }]}>
                    {createControl(item)}
                </Form.Item>
                    {props.isInbound}{props.isPart}</Col>)
            if ((index + 1) % 2 == 0 || props.data.length == index) {
                content.push(<Row>{
                    rowItems
                }</Row>);
                rowItems = [];
            }
        })
        return content;
    }

    return <>
        {props.data ? <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />
            {props.title ?? '属性信息'}
        </div> : <></>}
        {createContent()}
    </>
}
export default EAttributeForm;